import React, { useRef } from 'react';
import styled from 'styled-components';
import { Icon as _Icon, useLazyLoadImage } from 'tmt-ui-kit';

import Link from '~/components/Link/Link';
// import useOnScreen from '~/utils/hooks/use-on-screen';

import config from '~/config';

const Container = styled.div`
  width: 100%;
  height: 152px;
  margin: 24px 0;
  margin-top: 80px;
  padding: 0 104px;
  display: flex;
  border-radius: 6px;
  background-color: rgba(28, 182, 230, 0.12);
  @media (max-width: 768px) {
    padding: 16px 0 16px 20px;
    height: 139px;
  }
  @media (max-width: 320px) {
    padding: 28px 0px 28px 20px;
    margin-top: 40px;
    height: 139px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 44px;
  @media (max-width: 1024px) {
    width: 280px;
    margin-top: 32px;
  }
  @media (max-width: 768px) and (min-width: 601px) {
    width: 176px;
    margin-top: 0px;
  }
  @media (max-width: 600px) {
    width: 176px;
    margin-top: 0px;
  }
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 16px;
  color: ${props => props.theme.black};
  @media (max-width: 600px) {
    line-height: 1.7;
  }
  @media (max-width: 360px) {
    font-size: 14px;
  }
`;

const TryQuiz = styled.p`
  font-size: 20px;
  font-weight: 600;
  margin-top: 8px;
  color: ${props => props.theme.blue};
  @media (max-width: 600px) {
    font-size: 18px;
  }
  @media (max-width: 360px) {
    font-size: 14px;
  }
`;

const TryContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled(_Icon)`
  margin-left: 8px;
  color: ${props => props.theme.blue} !important;
  -webkit-text-stroke: 0.5px #1cb5e6;
  @media (max-width: 320px) {
    margin-left: 2px;
    font-size: 20px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  height: fit-content;
  margin-left: 128px;
  margin-top: -69px;
  @media (max-width: 768px) and (min-width: 601px) {
    margin-left: 0;
    margin-top: -96px;
  }
  @media (max-width: 600px) {
    margin-left: 0;
    margin-top: -27%;
  }
  @media (max-width: 320px) {
    margin-top: -64px;
  }
`;

const Image = styled.img`
  width:100%;
  height:100%;
  object-fit: contain;
  transition: ${props => props.theme.imageTransition};
  opacity: 0;
  @media (max-width: 600px) {
    &:not(:nth-child(2n)) {
      display: none;
    }
  }
`;

const QuizTopic = (props) => {
  const { logClickQuiz } = props;
  // if (!combinedDynamicLoaded) return null;
  // if (!userConfig.showQuiz) return null;
  const logClick = async () => {
    await logClickQuiz(window.location.pathname);
  };
  // const containerRef = useRef(null);
  // const imagesRefs = useRef([null, null, null]);
  const imageRef = [useRef(), useRef(), useRef()];
  // const isSeen = useOnScreen(containerRef);
  // useEffect(() => {
  //   if (isSeen) {
  //     imagesRefs.current.forEach((imgRef) => {
  //       const imageDom = imgRef;
  //       imageDom.src = imgRef.dataset.src;
  //       imageDom.srcSet = imgRef.dataset.srcSet;
  //     });
  //   }
  // }, [isSeen]);
  useLazyLoadImage(imageRef[0]);
  useLazyLoadImage(imageRef[1]);
  useLazyLoadImage(imageRef[2]);
  return (
    <Link to="/quiz" onClick={logClick}>
      <Container>
        <TextContainer>
          <Text>Haven&apos;t found your trip?</Text>
          <TryContainer>
            <TryQuiz>Try this quiz!</TryQuiz>
            <Icon name="chevron-right" />
          </TryContainer>
        </TextContainer>
        <ImageContainer>
          <Image
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            data-src={`${config.assetPath}/static/images/quiz-topic/quiz-travel-style.png`}
            data-srcSet={`${config.assetPath}/static/images/quiz-topic/quiz-travel-style@2x.png`}
            alt="Quiz-1"
            ref={imageRef[0]}
          />
          <Image
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            data-src={`${config.assetPath}/static/images/quiz-topic/quiz-choice.png`}
            data-srcSet={`${config.assetPath}/static/images/quiz-topic/quiz-choice@2x.png`}
            alt="Quiz-2"
            ref={imageRef[1]}
          />
          <Image
            src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
            data-src={`${config.assetPath}/static/images/quiz-topic/quiz-result.png`}
            data-srcSet={`${config.assetPath}/static/images/quiz-topic/quiz-result@2x.png`}
            alt="Quiz-3"
            ref={imageRef[2]}
          />
        </ImageContainer>
      </Container>
    </Link>
  );
};

export default QuizTopic;
